module.exports = __webpack_public_path__ + "static/duergar-3731672d9da56910bd52aa1a4ce83320.jpg";